"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

import type RichTextTemplate from "@/templates/RichText";
import { useLocale } from "@/components/providers/LocaleProvider";
import {
  ReadableArticle,
  ReadableCopy,
  readableFallback,
} from "@/components/readable";

const RichText = dynamic(() => import("@/templates/RichText"), {
  ssr: false,
  loading: readableFallback("min-h-[600px]"),
});

export default function ClientOnlyRichText(
  props: ComponentProps<typeof RichTextTemplate>,
) {
  const locale = useLocale();

  return (
    <ReadableCopy
      copy={
        <ReadableArticle
          content={props.content}
          authors={props.articleData?.authors}
          locale={locale}
        />
      }
    >
      <RichText {...props} />
    </ReadableCopy>
  );
}
